import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import * as paths from '../../../constants/pathConstants';
import {ESTABLISHMENT_STATUS} from '../../../constants/EstablishmentStatusEnumeration';
import {ESTABLISHMENT_STATE_RULES_ENUMERATION as establishmentEnumeration}  from '../../../constants/EstablishmentStatusEnumeration';
import { is301Required } from '../../common/Utility';

const EstablishmentsRowMobile = ({establishment, onSelect, isSelected, evenRow, hideStatus})=> {
  let establishment_status = '';
  let establishment_301_status = ''; //eslint-disable-line no-unused-vars
  const caseDataRequired = getCaseDataRequired(establishment)

  function getCaseDataRequired(establishment) {
    return is301Required(establishment)
      .then(status => {
        return status;
      });
  }

  if(establishment.submission_status == 2 || establishment.submission_status == 3){
    //grab id from "/oshaApi/v1/submissions/{id}"
    let currentYear = new Date().getFullYear()-1;
    let index = establishment.years_submitted ? establishment.years_submitted.indexOf(currentYear) : -1;
    let submission_link = '';
    let submission_id = '';
    if (index !== -1) {
      submission_link = establishment.links.submission_links[index];
      submission_id = submission_link.split('/').pop();
      establishment_status = (
      <Link
        to={
        `${paths.pathToEstablishmentsDashboardPage}/${establishment.id}`+
        `${paths.pathToSubmissionPage}/${submission_id}`}>
        Submitted
      </Link>);
    }
    else {
      establishment_status = 'Submitted';
    }
  }
  else{
    establishment_status = 'Not Submitted';
  }

  if (caseDataRequired == 1) {
    establishment_301_status = 'Not Required to File';
  } else if (caseDataRequired == 2 || caseDataRequired == 3) {

    if (establishment.combined_submission_status == 0 ) {
        if (establishment.submission_status == 1) {
          establishment_301_status = 'Pending 300A';
        } else if (establishment.submission_status == 2 || establishment.submission_status == 3) {
          establishment_301_status = `${establishment.total_submitted_cases} ${establishment.total_submitted_cases == 1 ? ' case out of ' : ' cases out of '} + ${establishment.expected_cases_count} added`;
        }
    } else if (establishment.combined_submission_status == 1) {
      establishment_301_status = `${establishment.total_submitted_cases} ${establishment.total_submitted_cases == 1 ? ' case out of ' : ' cases out of '} + ${establishment.expected_cases_count} submitted`;
    }
  }

  /*if(ESTABLISHMENT_STATUS[establishment.submission_status] === 'Submitted'){
    let submission_id = establishment.links.submission_links.slice(-1)[0].split('/').slice(-1);
    establishment_status = (
      <Link
        to={
          `${paths.pathToEstablishmentsDashboardPage}/${establishment.id}`+
          `${paths.pathToSubmissionPage}/${submission_id}`}>
          Submitted
      </Link>);
  }
  else{
    establishment_status = ESTABLISHMENT_STATUS[establishment.submission_status];
  }

  const excludedStatesData = window.getExcludedStatesData();
  let managed_by_state_plan = false;
  if (excludedStatesData['fully_excluded_states'].includes(establishment.address.state.toUpperCase())) {
    managed_by_state_plan = true;
  }
  else if (excludedStatesData['partially_excluded_states'].includes(establishment.address.state.toUpperCase()) &&
    (establishment.establishment_type == establishmentEnumeration.STATE_GOVERNMENT || establishment.establishment_type == establishmentEnumeration.LOCAL_GOVERNMENT)) {
    managed_by_state_plan = true;
  }
  if (managed_by_state_plan) {
    establishment_301_status = 'Please check your state plan';
    if (establishment.total_submitted_cases > 0 ) {
      if (typeof establishment.expected_cases_count === 'undefined') {
        establishment_301_status = 'Status pending update';
      }
      else {
        establishment_301_status = establishment.total_submitted_cases + ' case out of ' + establishment.expected_cases_count + ' added';
      }
    }
  }
  else {
    if (!establishment.required_to_file301) {
      establishment_301_status = 'Not required to file 300/301';
    }
    else {
      // Not added yet
      if (establishment.submission_status == 1) {
        establishment_301_status = ESTABLISHMENT_STATUS[establishment.submission_status];
      }
      else {
        if (typeof establishment.expected_cases_count === 'undefined') {
          establishment_301_status = 'Status pending update';
        }
        else {
          establishment_301_status = establishment.total_submitted_cases + ' case out of ' + establishment.expected_cases_count + ' added';
        }
      }
    }
  }*/

  let estabPrefix =  establishment.establishment_status===2
    ? <i>[Inactive] </i>
    : "";
  let zip = establishment.address.zip.length == 5 ?
          establishment.address.zip :
          establishment.address.zip.slice(0, 5)
            + "-" + establishment.address.zip.slice(5);

  return (
    <tr className={evenRow ? "even-row" : ""}>
      <td className="checkbox-cell">
        {establishment.submission_status==2 &&
          establishment.establishment_status==1 && <input
          type="checkbox"
          name="submit-reports"
          checked = {isSelected}
          value={establishment.id}
          onChange={onSelect}
          />}
      </td>
      {hideStatus ?
      <td className="establishment-info">
        <div>{estabPrefix}
          <Link to={`${paths.pathToEstablishmentsDashboardPage}/${establishment.id}`}>
           {establishment.establishment_name}
          </Link>
        </div>
        <div>{establishment.address.street}</div>

        <div>{establishment.address.city + " "+
        establishment.address.state + " " + zip
        }
        </div>
        <div>
          <strong>EIN: </strong>{establishment.ein && establishment.ein.ein}
        </div>
      </td> :
      <td className="establishment-info">
      <div>{estabPrefix}
        <Link to={`${paths.pathToEstablishmentsDashboardPage}/${establishment.id}`}>
         {establishment.establishment_name}
        </Link>
      </div>
      <div>{establishment.address.street}</div>

      <div>{establishment.address.city + " "+
      establishment.address.state + " " + zip
      }
      </div>
      <div>
        <strong>EIN: </strong>{establishment.ein && establishment.ein.ein}
      </div>
      <strong>300A Status: </strong> {establishment_status}
    </td>}
    </tr>
  );
};

EstablishmentsRowMobile.propTypes ={
  establishment: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  evenRow: PropTypes.number,
  hideStatus: PropTypes.bool
};

export default EstablishmentsRowMobile;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentsTable/EstablishmentsRowMobile.js
 **/